var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTowels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 31.6667H95.0001C106.942 31.6667 112.913 31.6667 116.623 35.3768C120.333 39.0867 120.333 45.0578 120.333 57.0001V76.0001C120.333 87.9422 120.333 93.9133 116.623 97.6233C112.913 101.333 106.942 101.333 95.0001 101.333H76.0001C64.0579 101.333 58.0867 101.333 54.3767 97.6233C50.6667 93.9133 50.6667 87.9422 50.6667 76.0001V50.6667M41.1667 31.6667C35.92 31.6667 31.6667 35.92 31.6667 41.1667V50.6667H50.6667M41.1667 31.6667C46.4135 31.6667 50.6667 35.92 50.6667 41.1667V50.6667M107.667 101.333C107.667 113.276 107.667 119.247 103.957 122.957C100.247 126.667 94.2755 126.667 82.3334 126.667H57.0001C45.0578 126.667 39.0867 126.667 35.3768 122.957C31.6667 119.247 31.6667 113.276 31.6667 101.333V69.6667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1667 31.6667H95.0001C106.942 31.6667 112.913 31.6667 116.623 35.3768C120.333 39.0867 120.333 45.0578 120.333 57.0001V76.0001C120.333 87.9422 120.333 93.9133 116.623 97.6233C112.913 101.333 106.942 101.333 95.0001 101.333H76.0001C64.0579 101.333 58.0867 101.333 54.3767 97.6233C50.6667 93.9133 50.6667 87.9422 50.6667 76.0001V50.6667M41.1667 31.6667C35.92 31.6667 31.6667 35.92 31.6667 41.1667V50.6667H50.6667M41.1667 31.6667C46.4135 31.6667 50.6667 35.92 50.6667 41.1667V50.6667M107.667 101.333C107.667 113.276 107.667 119.247 103.957 122.957C100.247 126.667 94.2755 126.667 82.3334 126.667H57.0001C45.0578 126.667 39.0867 126.667 35.3768 122.957C31.6667 119.247 31.6667 113.276 31.6667 101.333V69.6667",
    stroke: "url(#paint0_linear_16725_947)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 25.3333V31.6666C139.333 37.5685 139.333 40.5194 138.369 42.8473C137.084 45.9509 134.618 48.4168 131.514 49.7024C129.186 50.6666 126.235 50.6666 120.333 50.6666M12.6667 25.3333V31.6666C12.6667 37.5685 12.6667 40.5194 13.6309 42.8473C14.9165 45.9509 17.3824 48.4168 20.4861 49.7024C22.8139 50.6666 25.7648 50.6666 31.6667 50.6666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.333 25.3333V31.6666C139.333 37.5685 139.333 40.5194 138.369 42.8473C137.084 45.9509 134.618 48.4168 131.514 49.7024C129.186 50.6666 126.235 50.6666 120.333 50.6666M12.6667 25.3333V31.6666C12.6667 37.5685 12.6667 40.5194 13.6309 42.8473C14.9165 45.9509 17.3824 48.4168 20.4861 49.7024C22.8139 50.6666 25.7648 50.6666 31.6667 50.6666",
    stroke: "url(#paint1_linear_16725_947)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_947",
    x1: 31.6667,
    y1: 31.6667,
    x2: 138.068,
    y2: 59.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_947",
    x1: 12.6667,
    y1: 25.3333,
    x2: 66.4173,
    y2: 101.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowels);
export default __webpack_public_path__ + "static/media/towels.1ecb018a3b3d0185a7821cb56c30712f.svg";
export { ForwardRef as ReactComponent };